import { render, staticRenderFns } from "./DocCaisse.vue?vue&type=template&id=1a53149b&"
import script from "./DocCaisse.vue?vue&type=script&lang=js&"
export * from "./DocCaisse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports